import { ReactComponent as AccountNumber } from "../../images/inline-svg/account-number.svg";
import { ReactComponent as AdditionalCardHolder } from "../../images/inline-svg/additional-card-holder.svg";
import { ReactComponent as CustomerServiceRep } from "../../images/inline-svg/customer-service-rep.svg";
import { ReactComponent as IconCar } from "../../images/inline-svg/icon-car.svg";
import { ReactComponent as IconMenu } from "../../images/inline-svg/icon-menu.svg";
import { ReactComponent as IconSuccess } from "../../images/inline-svg/icon-success.svg";
import { ReactComponent as LogoNzWhite } from "../../images/inline-svg/logo-nz-white.svg";
import { ReactComponent as Alert_icon } from "../../images/inline-svg/alert_icon.svg";
import { ReactComponent as CustomerServiceWaving } from "../../images/inline-svg/customer-service-waving.svg";
import { ReactComponent as IconCardExpiryCalendar } from "../../images/inline-svg/icon-card-expiry-calendar.svg";
import { ReactComponent as IconTickGreen } from "../../images/inline-svg/icon-tick-green.svg";
import { ReactComponent as LogoNz } from "../../images/inline-svg/logo-nz.svg";
import { ReactComponent as Bills } from "../../images/inline-svg/bills.svg";
import { ReactComponent as DirectDebitPaymentCancel } from "../../images/inline-svg/direct-debit-payment-cancel.svg";
import { ReactComponent as IconCard } from "../../images/inline-svg/icon-card.svg";
import { ReactComponent as IconPerson } from "../../images/inline-svg/icon-person.svg";
import { ReactComponent as IconTickSmall } from "../../images/inline-svg/icon-tick-small.svg";
import { ReactComponent as MobileWithCross } from "../../images/inline-svg/mobile-with-cross.svg";
import { ReactComponent as Blocking } from "../../images/inline-svg/blocking.svg";
import { ReactComponent as DirectDebitPayment } from "../../images/inline-svg/direct-debit-payment.svg";
import { ReactComponent as IconCard2 } from "../../images/inline-svg/icon-card2.svg";
import { ReactComponent as IconQuestion } from "../../images/inline-svg/icon-question.svg";
import { ReactComponent as IconTick } from "../../images/inline-svg/icon-tick.svg";
import { ReactComponent as NoInterestFree } from "../../images/inline-svg/no-interest-free.svg";
import { ReactComponent as Break } from "../../images/inline-svg/break.svg";
import { ReactComponent as Document } from "../../images/inline-svg/document.svg";
import { ReactComponent as IconCelebrate } from "../../images/inline-svg/icon-celebrate.svg";
import { ReactComponent as IconReduceCredit } from "../../images/inline-svg/icon-reduce-credit.svg";
import { ReactComponent as IconTravel } from "../../images/inline-svg/icon-travel.svg";
import { ReactComponent as NoTransactions } from "../../images/inline-svg/no-transactions.svg";
import { ReactComponent as CardExpiryDate } from "../../images/inline-svg/card-expiry-date.svg";
import { ReactComponent as ErrorCards } from "../../images/inline-svg/error-cards.svg";
import { ReactComponent as IconCloseAccount } from "../../images/inline-svg/icon-close-account.svg";
import { ReactComponent as IconRefresh } from "../../images/inline-svg/icon-refresh.svg";
import { ReactComponent as IconViewStatements } from "../../images/inline-svg/icon-view-statements.svg";
import { ReactComponent as ReduceCreditLimit } from "../../images/inline-svg/reduce-credit-limit.svg";
import { ReactComponent as IncreaseCreditLimit } from "../../images/inline-svg/increase-credit-limit.svg";
import { ReactComponent as ReduceCreditLimitBlock } from "../../images/inline-svg/reduce-limit-block.svg";
import { ReactComponent as ThirdPartyAuthority } from "../../images/inline-svg/third-party-authority.svg";
import { ReactComponent as ChevronBlue } from "../../images/inline-svg/chevron-blue.svg";
import { ReactComponent as ErrorDocuments } from "../../images/inline-svg/error-documents.svg";
import { ReactComponent as IconCross } from "../../images/inline-svg/icon-cross.svg";
import { ReactComponent as IconRibbonClosed } from "../../images/inline-svg/icon-ribbon-closed.svg";
import { ReactComponent as Info } from "../../images/inline-svg/info.svg";
import { ReactComponent as Success } from "../../images/inline-svg/success.svg";
import { ReactComponent as ChevronRight } from "../../images/inline-svg/chevron-right.svg";
import { ReactComponent as ErrorDog } from "../../images/inline-svg/error-dog.svg";
import { ReactComponent as IconDl } from "../../images/inline-svg/icon-dl.svg";
import { ReactComponent as IconRibbon } from "../../images/inline-svg/icon-ribbon.svg";
import { ReactComponent as Instagram } from "../../images/inline-svg/instagram.svg";
import { ReactComponent as Triangle } from "../../images/inline-svg/triangle.svg";
import { ReactComponent as Chevron } from "../../images/inline-svg/chevron.svg";
import { ReactComponent as Facebook } from "../../images/inline-svg/facebook.svg";
import { ReactComponent as IconDownload } from "../../images/inline-svg/icon-download.svg";
import { ReactComponent as IconSecurityLock } from "../../images/inline-svg/icon-security-lock.svg";
import { ReactComponent as Linkedin } from "../../images/inline-svg/linkedin.svg";
import { ReactComponent as Twitter } from "../../images/inline-svg/twitter.svg";
import { ReactComponent as CloseAccountIllustration } from "../../images/inline-svg/close-account-illustration.svg";
import { ReactComponent as Goodbye } from "../../images/inline-svg/goodbye.svg";
import { ReactComponent as IconEdit } from "../../images/inline-svg/icon-edit.svg";
import { ReactComponent as IconSetPinConfetti } from "../../images/inline-svg/icon-set-pin-confetti.svg";
import { ReactComponent as Youtube } from "../../images/inline-svg/youtube.svg";
import { ReactComponent as CloseAccount } from "../../images/inline-svg/close-account.svg";
import { ReactComponent as IconEyeHidden } from "../../images/inline-svg/icon-Eye-Hidden.svg";
import { ReactComponent as IconExclamation } from "../../images/inline-svg/icon-exclamation.svg";
import { ReactComponent as IconSetPin } from "../../images/inline-svg/icon-set-pin.svg";
import { ReactComponent as LogoAuWhite } from "../../images/inline-svg/logo-au-white.svg";
import { ReactComponent as Confetti } from "../../images/inline-svg/confetti.svg";
import { ReactComponent as IconEyeVisible } from "../../images/inline-svg/icon-Eye-Visible.svg";
import { ReactComponent as IconLightning } from "../../images/inline-svg/icon-lightning.svg";
import { ReactComponent as IconStar } from "../../images/inline-svg/icon-star.svg";
import { ReactComponent as LogoAu } from "../../images/inline-svg/logo-au.svg";
import { ReactComponent as CreditCard } from "../../images/inline-svg/credit-card.svg";
import { ReactComponent as PersonalLoan } from "../../images/inline-svg/personal-loan.svg";
import { ReactComponent as CreditCardNumber } from "../../images/inline-svg/credit-card-number.svg";
import { ReactComponent as IconTickLargeCircle } from "../../images/inline-svg/icon-Tick-Large-Circle.svg";
import { ReactComponent as IconMeasuringTape } from "../../images/inline-svg/icon-measuring-tape.svg";
import { ReactComponent as IconSuccessTick } from "../../images/inline-svg/icon-success-tick.svg";
import { ReactComponent as LogoFb } from "../../images/inline-svg/logo-fb.svg";
import { ReactComponent as Letter } from "../../images/inline-svg/letter.svg";
import { ReactComponent as MailClosed } from "../../images/inline-svg/mail-closed.svg";
import { ReactComponent as CreditCardsAttention } from "../../images/inline-svg/credit-cards-attention.svg";
import { ReactComponent as Visa } from "../../images/inline-svg/visa.svg";
import { ReactComponent as VisaDisabled } from "../../images/inline-svg/visa-disabled.svg";
import { ReactComponent as MasterCard } from "../../images/inline-svg/mastercard.svg";
import { ReactComponent as MasterCardDisabled } from "../../images/inline-svg/mastercard-disabled.svg";
import { ReactComponent as Delete } from "../../images/inline-svg/delete.svg";
import { ReactComponent as Plane } from "../../images/inline-svg/plane.svg";
import { ReactComponent as Hardship } from "../../images/inline-svg/hardship.svg";
import { ReactComponent as StatementsNowAvailable } from "../../images/inline-svg/statements-now-available.svg";
import { ReactComponent as IconCalendar } from "../../images/inline-svg/icon-calendar.svg";
import { ReactComponent as ChangedStatementPreference } from "../../images/inline-svg/changed-statement-preference.svg";
import { ReactComponent as CoreLocation } from "../../images/inline-svg/core-location.svg";
import { ReactComponent as Magnifier } from "../../images/inline-svg/magnifier.svg";
import { ReactComponent as StatementPreference } from "../../images/inline-svg/statement-preference.svg";
import { ReactComponent as LostStolenDamaged } from "../../images/inline-svg/lost-stolen-damaged-card.svg";
import { ReactComponent as TakeABreak } from "../../images/inline-svg/take-a-break.svg";

export const SvgMapping = {
  "account-number": AccountNumber,
  "additional-card-holder": AdditionalCardHolder,
  "customer-service-rep": CustomerServiceRep,
  "icon-car": IconCar,
  "icon-menu": IconMenu,
  "icon-success": IconSuccess,
  "logo-nz-white": LogoNzWhite,
  alert_icon: Alert_icon,
  "customer-service-waving": CustomerServiceWaving,
  "icon-card-expiry-calendar": IconCardExpiryCalendar,
  "icon-tick-green": IconTickGreen,
  "logo-nz": LogoNz,
  bills: Bills,
  delete: Delete,
  "direct-debit-payment-cancel": DirectDebitPaymentCancel,
  "icon-card": IconCard,
  "icon-person": IconPerson,
  "icon-tick-small": IconTickSmall,
  "mobile-with-cross": MobileWithCross,
  blocking: Blocking,
  "direct-debit-payment": DirectDebitPayment,
  "icon-card2": IconCard2,
  "icon-question": IconQuestion,
  "icon-tick": IconTick,
  "no-interest-free": NoInterestFree,
  break: Break,
  document: Document,
  "icon-celebrate": IconCelebrate,
  "icon-reduce-credit": IconReduceCredit,
  "icon-travel": IconTravel,
  "no-transactions": NoTransactions,
  "card-expiry-date": CardExpiryDate,
  "error-cards": ErrorCards,
  "icon-close-account": IconCloseAccount,
  "icon-refresh": IconRefresh,
  "icon-view-statements": IconViewStatements,
  "reduce-credit-limit": ReduceCreditLimit,
  "reduce-limit-block": ReduceCreditLimitBlock,
  "third-party-authority": ThirdPartyAuthority,
  "increase-credit-limit": IncreaseCreditLimit,
  "chevron-blue": ChevronBlue,
  "error-documents": ErrorDocuments,
  "icon-cross": IconCross,
  "icon-ribbon-closed": IconRibbonClosed,
  info: Info,
  success: Success,
  "chevron-right": ChevronRight,
  "error-dog": ErrorDog,
  "icon-dl": IconDl,
  "icon-ribbon": IconRibbon,
  instagram: Instagram,
  triangle: Triangle,
  chevron: Chevron,
  facebook: Facebook,
  "icon-download": IconDownload,
  "icon-security-lock": IconSecurityLock,
  linkedin: Linkedin,
  twitter: Twitter,
  "close-account-illustration": CloseAccountIllustration,
  goodbye: Goodbye,
  "icon-edit": IconEdit,
  "icon-set-pin-confetti": IconSetPinConfetti,
  youtube: Youtube,
  "close-account": CloseAccount,
  "icon-Eye-Hidden": IconEyeHidden,
  "icon-exclamation": IconExclamation,
  "icon-set-pin": IconSetPin,
  "logo-au-white": LogoAuWhite,
  confetti: Confetti,
  "icon-Eye-Visible": IconEyeVisible,
  "icon-lightning": IconLightning,
  "icon-star": IconStar,
  "logo-au": LogoAu,
  "credit-card": CreditCard,
  "credit-card-number": CreditCardNumber,
  "icon-Tick-Large-Circle": IconTickLargeCircle,
  "icon-measuring-tape": IconMeasuringTape,
  "icon-success-tick": IconSuccessTick,
  "logo-fb": LogoFb,
  letter: Letter,
  "mail-closed": MailClosed,
  "credit-card-attention": CreditCardsAttention,
  visa: Visa,
  "visa-disabled": VisaDisabled,
  "master-card": MasterCard,
  "master-card-disabled": MasterCardDisabled,
  plane: Plane,
  hardship: Hardship,
  "statements-now-available": StatementsNowAvailable,
  "icon-calendar": IconCalendar,
  "changed-statement-preference": ChangedStatementPreference,
  "core-location": CoreLocation,
  magnifier: Magnifier,
  "statement-preference": StatementPreference,
  "personal-loan": PersonalLoan,
  "lost-stolen-damaged-card": LostStolenDamaged,
  "take-a-break": TakeABreak,
};
